var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-carousel",
    {
      attrs: {
        indicator: _vm.deviceWidth <= 960,
        "indicator-inside": false,
        animated: "fade",
        interval: _vm.interval,
        autoplay: true,
      },
    },
    _vm._l(_vm.slidesToUse, function (id, i) {
      return _c(
        "b-carousel-item",
        { key: i },
        [
          _c("b-image", {
            staticClass: "image",
            attrs: {
              src: "https://drive.google.com/thumbnail?id=" + id + "&sz=w600",
            },
          }),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }